import { BrowserRouter, Route, Routes } from 'react-router-dom';

import ContactPage from '../../pages/ContactPage/ContactPage';
import GalleryPage from '../../pages/GalleryPage/GalleryPage';
import LocationPage from '../../pages/LocationPage/LocationPage';
import MainPage from '../../pages/MainPage/MainPage';
import NotFoundPage from '../../pages/NotFoundPage/NotFoundPage';
// import OverviewPage from '../../pages/OverviewPage/OverviewPage';
import ReservePage from '../../pages/ReservePage/ReservePage';
import ScrollToTop from '../ScrollToTop/ScrollToTop';
import SiteLayout from '../SiteLayout/SiteLayout';

import './App.css';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route element={<SiteLayout />}>
          <Route index element={<MainPage />} />
          <Route path="location" element={<LocationPage />} />
          <Route path="gallery" element={<GalleryPage />} />
          <Route path="reservation" element={<ReservePage />} />
          {/* <Route path="overview" element={<OverviewPage />} /> */}
          <Route path="contact" element={<ContactPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
